import api from './api';

// Blog Posts
export const getBlogPosts = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await api.get(`/blog/admin/all?${queryParams}`);
  return response.data;
};

export const getBlogPostById = async (id) => {
  const response = await api.get(`/blog/${id}`);
  return response.data;
};

export const createBlogPost = async (data) => {
  const response = await api.post('/blog', data);
  return response.data;
};

export const updateBlogPost = async (id, data) => {
  const response = await api.put(`/blog/${id}`, data);
  return response.data;
};

export const deleteBlogPost = async (id) => {
  const response = await api.delete(`/blog/${id}`);
  return response.data;
};

// Comments
export const getComments = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await api.get(`/blog/comments/all?${queryParams}`);
  return response.data;
};

export const approveComment = async (commentId) => {
  const response = await api.put(`/blog/comments/${commentId}/approve`);
  return response.data;
};

export const deleteComment = async (commentId) => {
  const response = await api.delete(`/blog/comments/${commentId}`);
  return response.data;
};

export const replyToComment = async (commentId, reply) => {
  const response = await api.post(`/blog/comments/${commentId}/reply`, { reply });
  return response.data;
};
